/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';

export enum SettingsSecurityActionType {
    OPEN_SETTINGS_SECURITY_PAGE = 'SettingsSecurity/ open page',
    EXIT_SETTINGS_SECURITY_PAGE = 'SettingsSecurity/ exit page',

    CHANGE_PASSWORD = 'SettingsSecurity/ change user password',
    CHANGE_PASSWORD_SUCCESS = 'SettingsSecurity/ change user password success',
    CHANGE_PASSWORD_ERROR = 'SettingsSecurity/ change user password error',
}

export const openSecurityPageAction = () => createAction(SettingsSecurityActionType.OPEN_SETTINGS_SECURITY_PAGE);

export const exitSecurityPageAction = () => createAction(SettingsSecurityActionType.EXIT_SETTINGS_SECURITY_PAGE);

export const changePasswordAction = (payload: { oldPassword: string; newPassword: string }) =>
    createAction(SettingsSecurityActionType.CHANGE_PASSWORD, payload);

export const changePasswordSuccessAction = () => createAction(SettingsSecurityActionType.CHANGE_PASSWORD_SUCCESS);

export const changePasswordErrorAction = (notification: Notification) =>
    createAction(SettingsSecurityActionType.CHANGE_PASSWORD_ERROR, { notification });

export type SettingsSecurityAction =
    | ReturnType<typeof openSecurityPageAction>
    | ReturnType<typeof exitSecurityPageAction>
    | ReturnType<typeof changePasswordAction>
    | ReturnType<typeof changePasswordSuccessAction>
    | ReturnType<typeof changePasswordErrorAction>;
